import { LensProductAvailabilityEnum } from "./lens-product-availability-enum";

export const lensProductAvailabilityLabels = {
  [LensProductAvailabilityEnum.READY]: "Ready",
  [LensProductAvailabilityEnum.PRE_ORDER]: "Pre-Order",
};
